import './Footer.scss';
import Component from './Footer.js';
export default Component;
